"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _ErrorNotificationIcon = _interopRequireDefault(require("./Assets/ErrorNotificationIcon"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

var _useDirection3 = _interopRequireDefault(require("../hooks/useDirection"));

var _useLocalizer = _interopRequireDefault(require("../hooks/useLocalizer"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ConnectivityStatusJavaScriptError = function ConnectivityStatusJavaScriptError() {
  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      errorNotificationStyleSet = _useStyleSet2[0].errorNotification;

  var _useDirection = (0, _useDirection3.default)(),
      _useDirection2 = _slicedToArray(_useDirection, 1),
      direction = _useDirection2[0];

  var localize = (0, _useLocalizer.default)();
  var renderErrorNotificationText = localize('CONNECTIVITY_STATUS_ALT_RENDER_ERROR');
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', renderErrorNotificationText)
  }), _react.default.createElement("div", {
    "aria-hidden": true,
    className: (0, _classnames.default)('webchat__connectivityStatus', errorNotificationStyleSet + ''),
    dir: direction
  }, _react.default.createElement(_ErrorNotificationIcon.default, null), renderErrorNotificationText));
};

var _default = ConnectivityStatusJavaScriptError;
exports.default = _default;